import { TLocalAuthContext } from '~/components/Auth';
import { COMMON_TAGS } from '../config/constants';
import {
  RumEvent,
  RumViewEventDomainContext,
  RumActionEventDomainContext,
  RumFetchResourceEventDomainContext,
  RumXhrResourceEventDomainContext,
  RumOtherResourceEventDomainContext,
  RumErrorEventDomainContext,
  RumLongTaskEventDomainContext,
  datadogRum,
} from '@datadog/browser-rum';
export { sendActionToDatadog } from '@mindtickle/ui-shell-core/Datadog';

export function getCompanyContext(company: TLocalAuthContext['company']) {
  return {
    id: company.id,
    name: company.name,
    learningSite: company.learningSite || window?.location?.hostname,
    isCustomer: company.isCustomer,
  };
}

export const sendCustomTimingToDatadog = (name: string, time?: number | undefined) => {
  datadogRum.addTiming(name, time);
};

// eslint-disable-next-line complexity
export async function setRouteChangeConfigForRepeatUsers(
  event: RumEvent,
  context:
    | RumViewEventDomainContext
    | RumActionEventDomainContext
    | RumFetchResourceEventDomainContext
    | RumXhrResourceEventDomainContext
    | RumOtherResourceEventDomainContext
    | RumErrorEventDomainContext
    | RumLongTaskEventDomainContext
) {
  try {
    if (
      event?.type === 'view' &&
      event?.view?.loading_type === 'route_change' &&
      // @ts-ignore
      event?.context?.owner?.app &&
      window.MTAppBuildVer &&
      // @ts-ignore
      window.MTAppBuildVer[event.context.owner.app] &&
      // @ts-ignore
      context?.location?.pathname
    ) {
      const mtBuildVer: string | null = localStorage.getItem(COMMON_TAGS.BUILD_VER_MAP);
      let mtBuildVerObj: Record<string, string> = {};
      //eslint-disable-next-line
      if (mtBuildVer) {
        mtBuildVerObj = JSON.parse(mtBuildVer) || mtBuildVerObj;
      }
      // @ts-ignore
      const { pathname } = context.location;
      const pathWithoutDigits: string = pathname.replace(/\d/g, '');
      // @ts-ignore
      mtBuildVerObj[pathWithoutDigits] = window.MTAppBuildVer[event.context.owner.app];
      localStorage.setItem(COMMON_TAGS.BUILD_VER_MAP, JSON.stringify(mtBuildVerObj));
    }
  } catch (e) {
    // console.log(e);
  }
}
